var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LazyLoader',{attrs:{"api-key":"homeBanner","wrap-class":"ad","skeleton-height":"89"},on:{"init":_vm.fetch,"show":_vm.reportShow}},[(_vm.banner.img_url)?_c('img',{attrs:{"src":_vm.banner.img_url},on:{"click":function($event){_vm.$util.bannerJump(_vm.banner)
      _vm.reportClick()}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }